module.exports = __webpack_public_path__ + "media/images/menu/venus-256a1fea9470cf10370dfc8881f03e24.jpg";